export const cibPdf = [
  '512 512',
  `
  <path fill="var(--ci-primary-color, currentColor)" d="M334.627,16H48V496H472V153.373ZM440,166.627V168H320V48h1.373ZM80,464V48H288V200H440V464Z" class="ci-primary"/>
  <text x="50%" y="72%"
        font-size="160"
        font-family="Tahoma"
        font-weight="bold"
        text-anchor="middle"
        fill="#e74c3c"
        opacity="0.95"
        style="paint-order: stroke; stroke: #fff; stroke-width: 2; stroke-opacity: 0.3">PDF</text>
  `,
]
